import { Fetch } from '../utils'
import { ApiEndpoints } from '../constants'
import type { GlobalErrorHandler, RepeatingTransaction } from '..'

export class RepeatingTransactionsApi {
  fetchInstance: Fetch

  constructor(endpoint: string, token: string, onError?: GlobalErrorHandler) {
    this.fetchInstance = new Fetch(endpoint, token, undefined, onError)
  }

  addRepeatingTransaction = async (repeatingTransaction: RepeatingTransaction) => {
    return this.fetchInstance
      .post(ApiEndpoints.REPEATING_TRANSACTIONS, repeatingTransaction)
      .then((data) => data.repeating_transaction)
  }

  getRepeatingTransactions = async () => {
    return this.fetchInstance
      .get(ApiEndpoints.REPEATING_TRANSACTIONS)
      .then((data) => data.repeating_transactions)
  }

  updateRepeatingTransaction = async (repeatingTransaction: RepeatingTransaction) => {
    return this.fetchInstance
      .put(
        `${ApiEndpoints.REPEATING_TRANSACTIONS}/${repeatingTransaction.guid}`,
        repeatingTransaction,
      )
      .then((data) => data.repeating_transaction)
  }

  deleteRepeatingTransaction = async (guid: string) => {
    return this.fetchInstance
      .delete(`${ApiEndpoints.REPEATING_TRANSACTIONS}/${guid}`)
      .then((data) => data)
  }
}
